export default __webpack_public_path__ + "static/media/elementalruin.d436fc02.png";